import React, { Component } from 'react';
import { Form, Control, Errors } from 'react-redux-form';
import {isRequired, required} from "../field_validations";
import _ from 'lodash';
import {confirmAlert} from "react-confirm-alert";
import DateTimePick from './../forms/datetimepicker';
import {NavLink} from 'react-router-dom';

class ContentFormVersions extends Component {
	render(){
		const { versions, groupsPhases } = this.props;
		let gc = _.find(groupsPhases.permissions, (o) => o === 'Create');
		return (
			<div className="columns is-centered">
				<Form className="column is-10" model="versions.edit" onSubmit={(values) => this._submitForm(values)} onSubmitFailed={() => this.props.setSystemNotification('¡Oh no!', 'Hay errores en el formulario', 'danger')}>
					<div className="hero is-light">
						<div className="hero-body">
							<div className="field is-grouped">
								<div className="control is-expanded">
									<label htmlFor="year" className="label">Año <span className="small has-text-danger">*</span></label>
									<Control.text model=".year" name="year" type="number" className="input" min={2000} max={3000} errors={{required}} validateOn="change"/>
									<Errors model=".year" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El año es obligatorio'}} />
								</div>

								<div className="control is-expanded">
									<label htmlFor="name" className="label">Titulo <span className="small has-text-danger">*</span></label>
									<Control.text model=".name" name="name" className="input" errors={{isRequired}} validateOn="change"/>
									<Errors model=".name" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El nombre es obligatorio'}} />
								</div>
							</div>

							<div className="field is-grouped">
								<div className="control is-expanded">
									<label htmlFor="start_date" className="label">Inicia <span className="small has-text-danger">*</span></label>
									<Control.text model=".start_date" name="start_date" id="start_date" component={DateTimePick} className="input" errors={{isRequired}} validateOn="change" />
									<Errors model=".start_date" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'La fecha es obligatorio'}}/>
								</div>

								<div className="control is-expanded">
									<label htmlFor="end_date" className="label">Termina <span className="small has-text-danger">*</span></label>
									<Control.text model=".end_date" name="end_date" id="end_date" component={DateTimePick} className="input" errors={{isRequired}} validateOn="change" />
									<Errors model=".end_date" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'La fecha es obligatorio'}}/>
								</div>

								<div className="control">
									<div className="message is-danger">
										<div className="message-body">
											<div className="field">
												<div className="control">
													<label htmlFor="finished" className="checkbox">
														<Control.checkbox model=".finished" id="finished" className="checkbox" isToggle={true} />
														<span style={{whiteSpace:'normal'}}> Finalizado </span>
													</label>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<hr />

					<div className="hero is-light">
						<div className="hero-body">
							<h5 className="title is-5">Añadir Proceso</h5>
							<div className="hero-subsection">
								<div className="field is-grouped">
									<div className="control is-expanded">
										<label htmlFor="temp_g_start_date" className="label">Inicia proceso <span className="small has-text-danger">*</span></label>
										<Control.text model=".temp_g_start_date"
										              name="temp_g_start_date"
										              id="temp_g_start_date"
										              value={versions.edit.temp_g_start_date ? versions.edit.temp_g_start_date:undefined}
										              component={DateTimePick}
										              className="input" />
										{versions.edit.temp_g_start_date ? '':
											<small className="help has-text-danger">Fecha requerida</small>}
									</div>

									<div className="control is-expanded">
										<label htmlFor="temp_g_end_date" className="label">Termina proceso <span className="small has-text-danger">*</span></label>
										<Control.text model=".temp_g_end_date"
										              name="temp_g_end_date"
										              id="temp_g_end_date"
										              value={versions.edit.temp_g_end_date ? versions.edit.temp_g_end_date:undefined}
										              component={DateTimePick}
										              className="input" />
										{versions.edit.temp_g_end_date ? '':
											<small className="help has-text-danger">Fecha requerida</small>}
									</div>

									{gc ?
										<div className="control">
											<div className="control">
												<label className="label">&nbsp;</label>
												<NavLink to={`/fases/grupos/crear`} className="button is-primary is-outlined">Nuevo proceso</NavLink>
											</div>
										</div> :''}
								</div>

								<div className="field has-addons">
									<div className="control">
										<label htmlFor="groups_phase" className="label">Procesos <span className="small has-text-danger">*</span></label>
										<div className="select">
											<select name="group_phase" id="group_phase" ref="group_phase"
											        value={this.state.group_phase ? this.state.group_phase:"ninguno"}
											        onChange={this._changeGroup}>
												<option value="ninguno">-- Seleccionar proceso --</option>
												{_.map(groupsPhases.list, (opt, k) => {
													return <option key={k} value={opt.id}>{opt.name}</option>
												})}
											</select>
										</div>
										{!this.state.group_phase && <small className="help has-text-danger">Proceso requerido</small>}
									</div>

									<div className="control">
										<label className="label">&nbsp;</label>
										<button type="button" className="button is-primary" onClick={() => {this._addGroups()}}>Agregar</button>
									</div>
								</div>
							</div>

							<hr/>

							{!_.isEmpty(versions.edit.phases_groups) ?
								<div className="hero-subsection">
									<label className="label">Listado de procesos</label>
									<table className="table is-fullwidth is-bordered">
										<thead>
										<tr>
											<th>#</th>
											<th>Proceso</th>
											<th>Inicia</th>
											<th>Termina</th>
											<th>Acciones</th>
										</tr>
										</thead>
										<tbody>
										{_.map(versions.edit.phases_groups,(row,k) => {
											return (
												<tr key={k}>
													<td>
														<strong>{k+1}</strong>
													</td>
													<td><strong>{row.name}</strong></td>
													<td>{row.start_date}</td>
													<td>{row.end_date}</td>
													<td style={{width:'10%'}}>
														<div className="field is-grouped">
															{!_.isEmpty(row.version_phase_group) ?
																<div className="control">
																	<NavLink to={`/versiones/editar/${versions.edit.year}/grupo/${row.id}`} className="button is-info"><i className="fa fa-edit" /></NavLink>
																</div> :''}
															<div className="control">
																<button type="button" onClick={() => this._getConfirm(k,row.name)} className="button is-danger"><i className="fa fa-trash" /></button>
															</div>
														</div>
													</td>
												</tr>
											)
										})}
										</tbody>
									</table>
								</div>
								:''}
						</div>
					</div>
					<br/>
					<div className="field is-grouped is-grouped-right">
						<div className="control">
							<button type="button" className="button is-large" onClick={() => this.props.history.push('/versiones')}>Regresar</button>
						</div>
						<div className="control">
							<Control.button model="versions.edit" className="button is-large is-inm-purple" type="submit" disabled={this._validateSave()}>Guardar</Control.button>
						</div>
					</div>
					<p className="has-text-grey has-text-right is-small">Los campos indicados con <span className="small has-text-danger">*</span> son obligatorios.</p>
				</Form>
			</div>
		)
	}

	constructor() {
		super();
		this.state = {
			canAdd: false,
			group_phase: undefined
		}
		this._changeGroup = this._changeGroup.bind(this);
	}

	_submitForm(values) {
		//console.log('values: ',values);
		this.props.versionSave(values);
	}

	_changeGroup(e){
		//console.log('e===>', e.target.value);
		if(e.target.value){
			return this.setState({
				group_phase: _.toInteger(e.target.value)
			});
		}
	}

	_getConfirm(index, name){
		confirmAlert({
			title: '¿Está seguro?',
			message: `¿Estás seguro/(a) de eliminar el Grupo "${name}"?`,
			confirmLabel: 'Aceptar',
			cancelLabel: 'Cancelar',
			onConfirm: () => this._removeGroup(index)
		})
	}

	_removeGroup(index) {
		this.props.remove('versions.edit.phases_groups', index);
	}

	_addGroups() {
		let { groupsPhases, versions } = this.props;
		if(this.state.group_phase !== undefined && versions.edit.temp_g_start_date !== undefined && versions.edit.temp_g_end_date!==undefined){
			let group = _.find(groupsPhases.list, {id: _.toInteger(this.state.group_phase)});
			this.props.add('versions.edit.phases_groups', {
				...group,
				start_date: versions.edit.temp_g_start_date,
				end_date: versions.edit.temp_g_end_date,
			});
			this.props.change(`versions.edit.temp_g_start_date`, undefined);
			this.props.change(`versions.edit.temp_g_end_date`, undefined);
			return this.setState({
				group_phase: undefined
			});
			//console.log(`agregar ==>`, group);
		}
	}

	_validateSave(){
		let {versions} = this.props;
		let vc = _.find(versions.permissions, (o) => {return o==='Create'});
		let vu = _.find(versions.permissions, (o) => {return o==='Update'});

		if(!_.isEmpty(versions.edit) && versions.edit.id){
			if(vu){
				return false;
			}else {
				return true;
			}
		}else if(!_.isEmpty(versions.edit) && _.isEmpty(versions.edit.id)){
			if(vc){
				return false;
			}else {
				return true;
			}
		}else {
			return true;
		}
	}
}

export default ContentFormVersions;


// WEBPACK FOOTER //
// ./src/elements/versions/form.jsx